import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './presentation/components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { initTheme } from './infrastructure/browser/theme';
import { initAnalytics } from './infrastructure/browser/analytics';

// Claro u oscuro antes de pintar nada, para que no parpadee.
initTheme();
initAnalytics();

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
// Ver el aviso de "no arrancó" en public/index.html.
(window as Window & { __domiotBooted?: boolean }).__domiotBooted = true;
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Cuándo se abrió la app o volvió a primer plano: en los primeros segundos
// recargar para estrenar la versión nueva no interrumpe a nadie.
let shownAt = Date.now();
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') shownAt = Date.now();
});
const FRESH_MS = 10 * 1000;

// Activa una versión nueva de la app sin esperar a que se cierren todas las
// pestañas (por defecto la PWA seguía con la vieja, que puede llamar a
// endpoints que ya no existen). Si la persona está usando la app, espera a
// que la deje en segundo plano para no recargarle la pantalla mientras escribe.
function applyUpdate(registration: ServiceWorkerRegistration) {
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
  const activate = () => registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
  if (document.visibilityState === 'hidden' || Date.now() - shownAt < FRESH_MS) {
    activate();
    return;
  }
  const onHidden = () => {
    if (document.visibilityState !== 'hidden') return;
    document.removeEventListener('visibilitychange', onHidden);
    activate();
  };
  document.addEventListener('visibilitychange', onHidden);
}

// Habilita el service worker (solo en producción, ver serviceWorkerRegistration.ts)
// para que la app sea instalable y funcione offline.
serviceWorkerRegistration.register({ onUpdate: applyUpdate });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
